import React from "react";
import Fallback from "../../components/Fallback";

const UserUpdateSelfProfile = React.lazy(
  () => import("./UserUpdateSelfProfile")
);
export const UserUpdateSelfProfileScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <UserUpdateSelfProfile {...props} />
  </React.Suspense>
);
